<div class="header-item-wrapper">

<!--  <div class="header-item">-->
<!--    <div class="menu-toggle-wrapper">-->
<!--      <div class="breadcrumb">-->
<!--        <ng-template ngFor let-item [ngForOf]="title">-->
<!--          <a *ngIf="item?.link" class="link-page" (click)="redirectToPage(item.url)">{{item?.name}} <span-->
<!--            class="lnr lnr-chevron-right"></span> <span class="lnr lnr-chevron-right second"></span></a>-->
<!--          <span class="header-title" *ngIf="!item?.link">{{item?.name}}</span>-->
<!--        </ng-template>-->
<!--      </div>-->
<!--    </div>-->
<!--  </div>-->

  <div class="header-wrapper">

    <div class="user" (touchstart)="showUserDrpdown()" [class.activeUser]="openedUserDrp">
      <div class="user-data">
        <div class="name">{{user?.firstName}}</div>
        <div class="name">{{user?.lastName}}</div>
        <div class="role">
          {{user?.role?.name}}
        </div>
      </div>
      <div class="user-icons">
        <span *ngIf="!imageUrl" class="lnr lnr-user in-circle"></span>
        <img [src]="imageUrl" *ngIf="imageUrl" alt="avatar" class="avatar">
        <span class="lnr lnr-chevron-down"></span>

      </div>
      <div class="dropdown">
        <div class="child-link" uiSrefActive="active" uiSref="app.userProfile">
          <span>Мой профиль</span>
        </div>
        <div class="child-link" (click)="onLogout()">
          <img src="./assets/images/power-off.png">
          <span>Выйти</span>
        </div>
      </div>
    </div>
  </div>
</div>
